/* GLOW PDP v19 (20 oct.) — timeline avant les badges, bandeau presse, GIF d'origine */
(function(){
  function isPDP(){return (window.location.pathname||'').indexOf('/products/')===0;}
  function isLift(){return /\/products\/glow-lift(\/|\?|#|$)/.test(window.location.pathname||'');}

  function moveStarsAboveTitle(){
    if(!isPDP()) return;
    var container=document.querySelector('.product__info-container');
    if(!container) return;
    var title=container.querySelector('.product__title');
    if(!title) return;
    var stars=null;
    Array.prototype.forEach.call(container.children,function(el){
      if(el.tagName==='A' && /★|✰|étoile|avis|reviews|jdgm/i.test(el.textContent||el.className)){
        if(!stars) stars=el;
      }
    });
    if(stars && !stars.dataset.glowMoved){
      container.insertBefore(stars,title);
      stars.dataset.glowMoved='1';
      stars.classList.add('glow-pdp-stars-top');
    }
  }

  function insertTimelineAtBottom(){
    if(!isPDP()) return;
    var container=document.querySelector('.product__info-container');
    if(!container || container.querySelector('.glow-timeline-pdp')) return;
    var today=new Date();
    var dayNames=['dim.','lun.','mar.','mer.','jeu.','ven.','sam.'];
    var monthNames=['janv.','févr.','mars','avr.','mai','juin','juil.','août','sept.','oct.','nov.','déc.'];
    function fmt(d){return dayNames[d.getDay()]+' '+d.getDate()+' '+monthNames[d.getMonth()];}
    function addBiz(start,days){var d=new Date(start);var added=0;while(added<days){d.setDate(d.getDate()+1);var dow=d.getDay();if(dow!==0&&dow!==6)added++;}return d;}
    var shipped=addBiz(today,1);
    var deliveredMin=addBiz(shipped,2);
    var deliveredMax=addBiz(shipped,3);
    function fmtRange(a,b){if(a.getMonth()===b.getMonth()) return dayNames[a.getDay()]+' '+a.getDate()+'-'+b.getDate()+' '+monthNames[a.getMonth()];return fmt(a)+' - '+b.getDate()+' '+monthNames[b.getMonth()];}
    var tblock=document.createElement('div');
    tblock.className='glow-timeline-pdp';
    tblock.innerHTML='<div class="glow-timeline-pdp__title">Le voyage de ta commande 🩷</div>'+
      '<div class="glow-timeline-pdp__track">'+
        '<div class="glow-timeline-pdp__step glow-timeline-pdp__step--active"><div class="glow-timeline-pdp__icon">📩</div><div class="glow-timeline-pdp__label">Commandé</div><div class="glow-timeline-pdp__date">'+fmt(today)+'</div></div>'+
        '<div class="glow-timeline-pdp__line"></div>'+
        '<div class="glow-timeline-pdp__step"><div class="glow-timeline-pdp__icon">📦</div><div class="glow-timeline-pdp__label">Expédié</div><div class="glow-timeline-pdp__date">'+fmt(shipped)+'</div></div>'+
        '<div class="glow-timeline-pdp__line"></div>'+
        '<div class="glow-timeline-pdp__step"><div class="glow-timeline-pdp__icon">🏠</div><div class="glow-timeline-pdp__label">Livré</div><div class="glow-timeline-pdp__date">'+fmtRange(deliveredMin,deliveredMax)+'</div></div>'+
      '</div>';
    var badges=null;
    Array.prototype.forEach.call(container.children,function(el){
      if(/grid-template-columns:\s*repeat\(2,\s*1fr\)/.test(el.getAttribute('style')||'')) badges=el;
    });
    if(badges) container.insertBefore(tblock,badges); else container.appendChild(tblock);
  }

  /* Point 6 : bloc preuves juste sous le bloc d'achat (après les 4 badges de réassurance) */
  function moveProofBlock(){
    var proof=document.querySelector('[data-glow-proof]');
    if(!proof || proof.dataset.glowPlaced) return;
    var container=document.querySelector('.product__info-container');
    if(!container) return;
    var anchor=null;
    Array.prototype.forEach.call(container.children,function(el){
      var st=el.getAttribute('style')||'';
      if(/grid-template-columns:\s*repeat\(2,\s*1fr\)/.test(st)) anchor=el;
    });
    if(!anchor){
      var form=container.querySelector('product-form, .product-form');
      if(form){anchor=form;while(anchor.parentNode && anchor.parentNode!==container){anchor=anchor.parentNode;}}
    }
    if(anchor && anchor.nextElementSibling && anchor.nextElementSibling.classList.contains('glow-press-pdp')) anchor=anchor.nextElementSibling;
    if(anchor && anchor.parentNode===container){container.insertBefore(proof,anchor.nextSibling);}
    else {container.appendChild(proof);}
    proof.dataset.glowPlaced='1';
  }

  /* Point 2 : plus de bloc Sérum -10 € sur la page Glow Lift */
  function hideSerumCrossSell(){
    if(!isLift()) return;
    document.querySelectorAll('.glow-crosssell').forEach(function(s){s.style.display='none';});
  }

  /* Point 8 : carrousel Avant / Pendant / Après à la place du gif */

  /* Point 9 : comparatif simplifié Glow Lift / recourbe-cils classique */
  function simplifyComparison(){
    document.querySelectorAll('.glow-comparison--lift').forEach(function(sec){
      if(sec.dataset.glowSimplified) return;
      var card=sec.querySelector('.glow-comparison__card');
      if(!card) return;
      var rows=[
        ['Temps','10 secondes','30 secondes'],
        ['Confort','Aucune douleur','Pince et tire les cils'],
        ['Tenue','Jusqu’à 24 h','2 h maximum'],
        ['Tes cils','Respecte la fibre','Casse la fibre']
      ];
      var curler='<img src="https://cdn.shopify.com/s/files/1/0916/4056/1928/files/classique.jpg?v=1792423324" alt="Recourbe-cils classique" loading="lazy">';
      var html='<div class="glow-cmp2" role="table" aria-label="Glow Lift comparé au recourbe-cils classique">'+
        '<div class="glow-cmp2__head" role="row">'+
          '<div class="glow-cmp2__col glow-cmp2__col--us" role="columnheader"><img src="https://cdn.shopify.com/s/files/1/0916/4056/1928/files/glowliftpremium.png?v=1787316448&width=300" alt="Glow Lift" loading="lazy"><span class="glow-cmp2__name">Glow Lift</span><span class="glow-cmp2__pill">La solution</span></div>'+
          '<div class="glow-cmp2__col" role="columnheader">'+curler+'<span class="glow-cmp2__name">Recourbe-cils classique</span></div>'+
        '</div>';
      rows.forEach(function(r){
        html+='<div class="glow-cmp2__row" role="row">'+
          '<div class="glow-cmp2__cell glow-cmp2__cell--us" role="cell"><span class="glow-cmp2__ic glow-cmp2__ic--ok" aria-hidden="true">✓</span><span><span style="display:block;font-size:10px;letter-spacing:1px;text-transform:uppercase;color:#E48BA4">'+r[0]+'</span>'+r[1]+'</span></div>'+
          '<div class="glow-cmp2__cell glow-cmp2__cell--them" role="cell"><span class="glow-cmp2__ic glow-cmp2__ic--no" aria-hidden="true">✗</span><span>'+r[2]+'</span></div>'+
        '</div>';
      });
      html+='</div>';
      card.outerHTML=html;
      var sub=sec.querySelector('.glow-comparison__subtitle');
      if(sub) sub.textContent='Glow Lift contre recourbe-cils classique, en 4 points.';
      sec.dataset.glowSimplified='1';
    });
  }

  /* Section À propos du Glow Lift : image "Ce que je reçois" sous le texte d'intro */
  function findAproposLift(){
    var found=null;
    document.querySelectorAll('h2').forEach(function(h){
      if(/le geste qui change tout/i.test(h.textContent||'')) found=h.closest('section');
    });
    return found;
  }
  function addCeQueJeRecois(){
    if(!isLift() || document.querySelector('.glow-recu')) return;
    var sec=findAproposLift();
    if(!sec) return;
    var para=null;
    sec.querySelectorAll('p').forEach(function(p){ if(/sans abîmer tes cils/i.test(p.textContent||'')) para=p; });
    if(!para) return;
    var fig=document.createElement('figure');
    fig.className='glow-recu';
    fig.innerHTML='<img src="https://cdn.shopify.com/s/files/1/0916/4056/1928/files/Produit_recus_glow_lift.png?v=1787316449&width=900" alt="Ce que tu reçois : Glow Lift, câble USB-C et pochette signature" loading="lazy"><figcaption>Ce que tu reçois dans ton colis</figcaption>';
    para.parentNode.insertBefore(fig,para.nextSibling);
  }

  /* Courte section Glow Sérum avec ajout au panier (la remise de 10 € s'applique au paiement) */
  function addSerumMini(){
    /* v21 : upsell "Complète ta routine" = passer au Glow Duo (remplace le Lift par le Duo) */
    if(!isLift() || document.querySelector('.glow-serum-mini')) return;
    var sec=findAproposLift();
    if(!sec) return;
    var box=document.createElement('section');
    box.className='glow-serum-mini glow-duo-up';
    box.innerHTML='<h2 class="glow-duo-up__heading">Adopte la routine complète 🩷</h2>'+
      '<div class="glow-serum-mini__card">'+
      '<a href="/products/glow-duo" class="glow-serum-mini__imglink"><img src="https://cdn.shopify.com/s/files/1/0916/4056/1928/files/glowliftcadeauxoffertseditorial.png?width=500" alt="Glow Duo : Glow Lift + Glow Sérum" loading="lazy"></a>'+
      '<div class="glow-serum-mini__txt">'+
        '<p class="glow-serum-mini__eyebrow">Le duo gagnant</p>'+
        '<p class="glow-serum-mini__title">Passe au Glow Duo : Lift + Sérum</p>'+
        '<p class="glow-serum-mini__desc">Recourbe avec le Glow Lift, nourris avec le Glow Sérum : des cils courbés <b>et</b> en pleine forme, jour après jour.</p>'+
        '<ul class="glow-serum-mini__list">'+
          '<li><b>Glow Sérum</b> : jojoba, sésame et vitamine E pour fortifier cils &amp; sourcils</li>'+
          '<li>Résultats visibles dès 4 semaines</li>'+
          '<li>🪮 <b>Brosse à cils offerte</b> avec le sérum</li>'+
          '<li>🩷 Pochette signature offerte</li>'+
        '</ul>'+
        '<p class="glow-serum-mini__price"><strong data-du-price>49,90 €</strong> <s data-du-old>71,98 €</s> <span data-du-diff>Tu économises 22,08 €</span></p>'+
        '<button type="button" class="glow-duo-up__btn" data-du-btn>Je passe au Duo 🩷</button>'+
        '<p class="glow-serum-mini__note">Le Glow Lift de ton panier est remplacé par le Duo, tu ne paies pas deux fois. <a href="/products/glow-duo">Voir le Glow Duo →</a></p>'+
      '</div></div>';
    sec.parentNode.insertBefore(box,sec.nextSibling);
    var duoId=null, liftPrice=null;
    function eur(c){return (c/100).toFixed(2).replace('.',',')+' €';}
    Promise.all([fetch('/products/glow-duo.js').then(function(r){return r.json();}),fetch('/products/glow-lift.js').then(function(r){return r.json();}),fetch('/products/glow-serum.js').then(function(r){return r.json();})]).then(function(res){
      var d=res[0].variants.filter(function(x){return x.available;})[0]||res[0].variants[0];
      var l=res[1].variants[0], sr=res[2].variants[0];
      if(!d){box.style.display='none';return;}
      duoId=d.id; liftPrice=l.price;
      box.querySelector('[data-du-price]').textContent=eur(d.price);
      var ref=(d.compare_at_price&&d.compare_at_price>d.price)?d.compare_at_price:(l.price+sr.price);
      box.querySelector('[data-du-old]').textContent=eur(ref);
      box.querySelector('[data-du-diff]').textContent=ref>d.price?'Tu économises '+eur(ref-d.price):'';
    }).catch(function(){box.style.display='none';});
    box.querySelector('[data-du-btn]').addEventListener('click',function(){
      var btn=this; if(!duoId) return; btn.disabled=true; btn.textContent='Un instant…';
      fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
        var upd={};
        (cart.items||[]).forEach(function(it){ if(it.handle==='glow-lift') upd[it.key]=0; });
        var p=Object.keys(upd).length?fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:upd})}):Promise.resolve();
        return p.then(function(){return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:duoId,quantity:1}]})});});
      }).then(function(){window.location.href='/cart';}).catch(function(){btn.disabled=false;btn.textContent='Je passe au Duo 🩷';window.location.href='/products/glow-duo';});
    });
  }

  /* Bandeau presse & télé (Gala, Cosmopolitan, ELLE, TF1+ sponsor Star Academy) sous "Le voyage de ta commande" */
  var GLOW_PRESS_LOGOS=[
    {src:'gala_v2_bandeau.png?v=1782479533&width=300',alt:'Paru dans Gala',cls:''},
    {src:'cosmopolitan-logo.png?v=1785332070&width=400',alt:'Paru dans Cosmopolitan',cls:' glow-press__logo--wide'},
    {src:'elle-magazine-logo.jpg?v=1792426908&width=300',alt:'Paru dans ELLE',cls:' glow-press__logo--elle'},
    {src:'TF1.png?v=1792426650&width=120',alt:'TF1+',cls:' glow-press__logo--tf1',tv:'Sponsor officiel de la Star&nbsp;Academy'}
  ];
  function glowPressHTML(){
    var base='https://cdn.shopify.com/s/files/1/0916/4056/1928/files/';
    function group(hidden){
      var h='<div class="glow-press__group"'+(hidden?' aria-hidden="true"':'')+'>';
      for(var k=0;k<2;k++){
        GLOW_PRESS_LOGOS.forEach(function(l){
          var alt=(hidden||k>0)?'':l.alt;
          h+='<span class="glow-press__item'+(l.tv?' glow-press__item--tv':'')+'"><img src="'+base+l.src+'" alt="'+alt+'" loading="lazy" class="glow-press__logo'+l.cls+'">'+(l.tv?'<span class="glow-press__tv">'+l.tv+'</span>':'')+'</span>';
        });
      }
      return h+'</div>';
    }
    return '<section class="glow-press" aria-label="Glow Lashes dans la presse et à la télé"><p class="glow-press__label">Vu dans la presse &amp; à la télé</p><div class="glow-press__viewport"><div class="glow-press__track">'+group(false)+group(true)+'</div></div></section>';
  }
  function insertPressBand(){
    if(!isPDP()) return;
    var container=document.querySelector('.product__info-container');
    if(!container || container.querySelector('.glow-press')) return;
    var anchor=null;
    Array.prototype.forEach.call(container.children,function(el){
      if(/grid-template-columns:\s*repeat\(2,\s*1fr\)/.test(el.getAttribute('style')||'')) anchor=el;
    });
    if(!anchor) anchor=container.querySelector('.glow-timeline-pdp');
    if(!anchor) return;
    var wrap=document.createElement('div');
    wrap.className='glow-press-pdp';
    wrap.innerHTML=glowPressHTML();
    anchor.parentNode.insertBefore(wrap,anchor.nextSibling);
  }

  function fixReviewButton(){
    document.querySelectorAll('a, button').forEach(function(a){
      var txt=(a.textContent||'').trim().toLowerCase();
      if((txt==='écrire un avis'||txt.indexOf('écrire un avis')!==-1||txt==='ecrire un avis') && !a.dataset.glowFixed){
        a.dataset.glowFixed='1';
        a.addEventListener('click',function(e){
          e.preventDefault();
          var writeBtn=document.querySelector('.jdgm-write-rev-link, [data-jdgm-review-form]');
          if(writeBtn){writeBtn.click();return;}
          var widget=document.querySelector('#judgeme_product_reviews, .jdgm-widget');
          if(widget){widget.scrollIntoView({behavior:'smooth',block:'center'});setTimeout(function(){var wr=document.querySelector('.jdgm-write-rev-link');if(wr)wr.click();},900);} else {window.location.href='/products/glow-lift#judgeme_product_reviews';}
        });
      }
    });
  }


  function safe(fn){try{fn();}catch(e){if(window.console)console.warn('[glow]',e);}}
  function runAll(){
    if(!isPDP()) return;
    [moveStarsAboveTitle,insertTimelineAtBottom,insertPressBand,moveProofBlock,hideSerumCrossSell,simplifyComparison,addCeQueJeRecois,addSerumMini,fixReviewButton].forEach(safe);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){runAll();setTimeout(runAll,400);setTimeout(runAll,1200);});
  } else {
    runAll();setTimeout(runAll,400);setTimeout(runAll,1200);
  }
  document.addEventListener('shopify:section:load',function(){setTimeout(runAll,100);});
})();

/* v20 — vignettes produits : avant/après (alternance auto sur mobile, survol sur ordinateur) */
(function(){
  var LIFT='https://cdn.shopify.com/s/files/1/0916/4056/1928/files/AVANT.png?v=1787316448&width=600';
  var SERUM='https://cdn.shopify.com/s/files/1/0916/4056/1928/files/Avant_apres_serum.png?v=1787316448&width=600';
  [LIFT,SERUM].forEach(function(u){var i=new Image();i.src=u;});
  var MAP={'glow-lift':LIFT,'glow-duo':LIFT,'offre-a-ta-copine':LIFT,'glow-serum':SERUM,'glow-serum-x2':SERUM};
  var touch=window.matchMedia&&window.matchMedia('(hover: none)').matches;
  function css(){
    if(document.getElementById('glow-ba-css'))return;
    var s=document.createElement('style');s.id='glow-ba-css';
    s.textContent='.glow-ba{position:absolute;inset:0;z-index:3;opacity:0;transition:opacity .6s ease;pointer-events:none}.glow-ba img{width:100%;height:100%;object-fit:cover;display:block}.glow-ba span{position:absolute;left:8px;top:8px;background:#FBEAF0;color:#8D4058;font:700 10px/1 Arial,sans-serif;letter-spacing:1px;text-transform:uppercase;padding:5px 8px;border-radius:10px}.glow-ba.on{opacity:1}';
    document.head.appendChild(s);
  }
  function handleOf(card){
    var a=card.querySelector('a[href*="/products/"]');if(!a)return null;
    var m=a.getAttribute('href').match(/\/products\/([^/?#]+)/);return m?m[1]:null;
  }
  var cards=[];
  function hidePochette(){
    document.querySelectorAll('a[href*="/products/pochette-signature-backend-inventory"]').forEach(function(a){
      var li=a.closest('.grid__item')||a.closest('li')||a.closest('.card-wrapper'); if(li && !li.closest('cart-drawer, #CartDrawer, .cart-drawer, cart-items, .cart-item')) li.style.display='none';
    });
  }
  function scan(){
    css();hidePochette();
    document.querySelectorAll('.card-wrapper').forEach(function(card){
      if(card.dataset.glowBa)return;
      var h=handleOf(card);if(!h||!MAP[h])return;
      var media=card.querySelector('.card__media .media')||card.querySelector('.card__media');if(!media)return;
      card.dataset.glowBa='1';
      var o=document.createElement('div');o.className='glow-ba';
      o.innerHTML='<img src="'+MAP[h]+'" alt="Avant / après" decoding="async"><span>Avant / après</span>';
      media.appendChild(o);
      var im=o.querySelector('img');
      var ready=function(){o.dataset.ready='1';};
      if(im.complete&&im.naturalWidth)ready();else im.addEventListener('load',ready);
      cards.push(o);
      if(!touch){
        card.addEventListener('mouseenter',function(){if(o.dataset.ready)o.classList.add('on');});
        card.addEventListener('mouseleave',function(){o.classList.remove('on');});
      }
    });
  }
  var flip=false;
  function tick(){
    if(!touch)return;
    flip=!flip;
    cards.forEach(function(o,i){setTimeout(function(){o.classList.toggle('on',flip&&!!o.dataset.ready);},i*250);});
  }
  function init(){scan();setTimeout(scan,800);setInterval(scan,3000);setInterval(tick,3000);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();

/* v22 — vidéos chargées seulement quand elles arrivent à l'écran (vitesse mobile) */
(function(){
  function setup(){
    var vids=[].slice.call(document.querySelectorAll('video[data-glow-lazy]:not([data-glow-lazy-on])'));
    if(!vids.length)return;
    if(!('IntersectionObserver' in window)){vids.forEach(function(v){v.setAttribute('data-glow-lazy-on','1');v.preload='auto';v.play&&v.play().catch(function(){});});return;}
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){var v=e.target;
        if(e.isIntersecting){ if(v.preload!=='auto'){v.preload='auto';} var p=v.play(); if(p&&p.catch)p.catch(function(){}); }
        else if(!v.paused){ v.pause(); }
      });
    },{rootMargin:'200px 0px',threshold:0.01});
    vids.forEach(function(v){v.setAttribute('data-glow-lazy-on','1');v.muted=true;io.observe(v);});
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',setup);}else{setup();}
  setTimeout(setup,1500);
})();

/* v22 — avis : sans doublons, avis avec photo en premier, départ au début */
(function(){
  function tidy(){
    document.querySelectorAll('.glow-reviews__track').forEach(function(t){
      if(t.dataset.glowTidy)return; t.dataset.glowTidy='1';
      var seen={}, photo=[], text=[];
      [].slice.call(t.children).forEach(function(c){
        var key=((c.querySelector('.glow-reviews__body')||{}).textContent||'').trim().slice(0,80)+'|'+(((c.querySelector('.glow-reviews__reviewer')||{}).textContent||'').split('·')[0].trim());
        if(seen[key]){c.remove();return;} seen[key]=1;
        (c.querySelector('.glow-reviews__photo')?photo:text).push(c);
      });
      photo.concat(text).forEach(function(c){t.appendChild(c);});
      t.scrollLeft=0;
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',tidy);}else{tidy();}
})();

/* v23 — Pochette signature offerte : ajout automatique au panier (remplace Moonbundle)
   Si le panier contient un Glow Lift, un Glow Duo ou l'Offre à ta copine -> la pochette est ajoutée (1 seule).
   Sinon elle est retirée. Elle passe à 0 € grâce à la réduction automatique Shopify « Pochette signature offerte (v2) ».
   Si la pochette est en rupture, rien n'est ajouté. */
(function(){
  var POCHETTE_VARIANT=58448700571912, POCHETTE_HANDLE='pochette-signature-backend-inventory';
  var ELIGIBLE=['glow-lift','glow-duo','offre-a-ta-copine'];
  var busy=false, pending=false, timer=null, failedUntil=0;
  var nativeFetch=window.fetch.bind(window);
  var lastOwn=0;
  function sections(){
    var d=document.querySelector('cart-drawer');
    if(d&&typeof d.getSectionsToRender==='function'){try{return d.getSectionsToRender().map(function(s){return s.section||s.id;});}catch(e){}}
    return ['cart-drawer','cart-icon-bubble'];
  }
  /* v24 — rafraîchit le tiroir panier depuis Shopify (gère aussi l'état « panier vide ») */
  function render(){
    if(location.pathname.indexOf('/cart')===0&&!document.querySelector('cart-drawer.active, cart-drawer[open]')){location.reload();return;}
    return nativeFetch('/?sections=cart-drawer,cart-icon-bubble',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(s){
      var P=new DOMParser(), d=document.querySelector('cart-drawer');
      if(d&&s['cart-drawer']){
        var nd=P.parseFromString(s['cart-drawer'],'text/html').querySelector('cart-drawer');
        if(nd){
          var keep=['active','animate'].filter(function(c){return d.classList.contains(c);});
          d.innerHTML=nd.innerHTML; d.className=nd.className; keep.forEach(function(c){d.classList.add(c);});
          var ov=d.querySelector('#CartDrawer-Overlay'); if(ov&&typeof d.close==='function') ov.addEventListener('click',d.close.bind(d));
        }
      }
      var b=document.getElementById('cart-icon-bubble');
      if(b&&s['cart-icon-bubble']){var sec=P.parseFromString(s['cart-icon-bubble'],'text/html').querySelector('.shopify-section'); if(sec) b.innerHTML=sec.innerHTML;}
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }).catch(function(){});
  }
  /* v24 — si la pochette est seule dans le tiroir, on la masque tout de suite (évite d'afficher « 5 € » le temps de la retirer) */
  function giftOnlyGuard(){
    var d=document.querySelector('cart-drawer'); if(!d) return;
    var rows=d.querySelectorAll('.cart-item'); var only=rows.length>0;
    for(var i=0;i<rows.length;i++){ if(!/pochette/i.test(rows[i].innerText||rows[i].textContent||'')){only=false;break;} }
    d.classList.toggle('glow-gift-only',only);
    if(only) schedule(true);
  }
  try{ var st=document.createElement('style'); st.textContent='cart-drawer.glow-gift-only .cart-item,cart-drawer.glow-gift-only .drawer__footer,cart-drawer.glow-gift-only .cart-drawer__footer{display:none!important}'; document.head.appendChild(st);}catch(e){}
  function post(url,body){
    body.sections=sections(); body.sections_url=location.pathname;
    return nativeFetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)}).then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j;});});
  }
  function check(){
    if(busy){pending=true;return;} busy=true;
    nativeFetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){
      var eligible=false, lines=[];
      cart.items.forEach(function(it,i){
        if(ELIGIBLE.indexOf(it.handle)!==-1) eligible=true;
        if(it.handle===POCHETTE_HANDLE||it.variant_id===POCHETTE_VARIANT) lines.push({line:i+1,qty:it.quantity,key:it.key});
      });
      if(eligible&&!lines.length){
        if(Date.now()<failedUntil) return null;
        return post('/cart/add.js',{items:[{id:POCHETTE_VARIANT,quantity:1,properties:{'_glowGift':'pochette'}}]}).then(render).catch(function(){failedUntil=Date.now()+600000;});
      }
      if(!eligible&&lines.length){ return post('/cart/change.js',{id:lines[0].key,quantity:0}).then(render); }
      if(eligible&&lines.length&&lines[0].qty>1){ return post('/cart/change.js',{id:lines[0].key,quantity:1}).then(render); }
      return null;
    }).catch(function(){}).then(function(){busy=false; if(pending){pending=false; schedule();}});
  }
  function schedule(fast){clearTimeout(timer);timer=setTimeout(check,fast?50:300);}
  /* Détecte toute modification du panier (thème, Moonbundle, apps…) via les requêtes réseau terminées */
  try{
    new PerformanceObserver(function(list){
      list.getEntries().forEach(function(e){ if(/\/cart\/(add|change|update|clear)(\.js|\.json)?/.test(e.name)) schedule(); });
    }).observe({type:'resource',buffered:false});
  }catch(e){ setInterval(schedule,4000); }
  document.addEventListener('submit',function(e){var f=e.target; if(f&&f.action&&/\/cart\/add/.test(f.action)) setTimeout(schedule,1500);},true);
  function watchDrawer(){var d=document.querySelector('cart-drawer'); if(!d) return; try{new MutationObserver(function(){giftOnlyGuard();}).observe(d,{childList:true,subtree:true});}catch(e){} giftOnlyGuard();}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){schedule();watchDrawer();});}else{schedule();watchDrawer();}
})();
